import { render, staticRenderFns } from "./BatchPrint.vue?vue&type=template&id=ffbcf270&scoped=true&"
import script from "./BatchPrint.vue?vue&type=script&lang=js&"
export * from "./BatchPrint.vue?vue&type=script&lang=js&"
import style0 from "./BatchPrint.vue?vue&type=style&index=0&id=ffbcf270&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffbcf270",
  null
  
)

export default component.exports